import MuiButton from "@mui/material/Button";

/**
 * Facade over MUI Button. Customize defaults here.
 */
export default function Button(props) {
  return <MuiButton {...props} />;
}
